export const LOGO_MAX_SIZE = 3;
export const LOGO_ACCEPT_TYPES = 'image/png,image/jpg,image/jpeg,image/svg+xml';
export const LOGO_ACCEPT_TYPE_LABELS = ['jpg', 'jpeg', 'png', 'svg'];

export const CONTRACT_ACCEPT_TYPES = 'application/pdf';
export const CONTRACT_ACCEPT_TYPES_LABELS = ['pdf'];

export const MAILING_LIST_MAX_SIZE = 5;
export const MAILING_LIST_ACCEPT_TYPES = '.csv';
export const MAILING_LIST_ACCEPT_TYPE_LABELS = ['csv'];
